import { View, Text } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import { formatSerialNumber } from "../constants/serialNumbers";

const RestrictionsOnTheAppointedRepresentative = ({ serialNumber = 6 }) => {
  const styles = ContractStyles();

  return (
    <View style={[styles.flexColumn, styles.gap_sm]} break>
      <ContractListItem
        id="restrictions-on-the-appointed-representative"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Restrictions on the Appointed Representative
      </ContractListItem>
      <Text style={styles.buttonTextSmall}>
        The Appointed Representative must not in the 12 months following the
        termination of this Contract, whether directly or indirectly, persuade
        or induce or attempt to persuade or induce any Appointed Representative
        to terminate their Contract with the Company with a view to providing
        Services in competition with the Company.
      </Text>

    </View>
  );
};

export default RestrictionsOnTheAppointedRepresentative;
